import { render, staticRenderFns } from "./ReportedMessages.vue?vue&type=template&id=40691783&scoped=true&"
import script from "./ReportedMessages.vue?vue&type=script&lang=js&"
export * from "./ReportedMessages.vue?vue&type=script&lang=js&"
import style0 from "./ReportedMessages.vue?vue&type=style&index=0&id=40691783&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40691783",
  null
  
)

export default component.exports